import React from "react";
import {store} from "app/redux/redux";
import T from "app/i18n/T";

export const isValid = (field: any) => store.getState().validation.filter((f: any) => f.field === field).length > 0;

export const getMsg = (field: any) => store.getState().validation.filter((f: any) => f.field === field).map((f: any, index: number) => {
        return <div key={field + index}>{T(f.msg)}</div>
    });
